"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ConditionLine = exports.createItem = void 0;
const HorizontalStack_1 = __importDefault(require("@mdigital/components/dist/components/HorizontalStack"));
const react_1 = __importDefault(require("react"));
const styled_components_1 = __importDefault(require("styled-components"));
const OperatorSelect_1 = require("./OperatorSelect");
const operators_1 = require("../operators");
const SubjectSelect_1 = require("./SubjectSelect");
const subjectDefinition_1 = require("./subjectDefinition");
const ValueInput_1 = require("./ValueInput");
const react_final_form_1 = require("react-final-form");
const final_form_1 = require("final-form");
const utils_1 = require("../../../../common/utils");
const RequiredValueText = 'app.pages.forms.builder.tabs.fieldSettings.conditionalDisplayModal.required';
const InvalidRegexText = 'app.pages.forms.builder.tabs.fieldSettings.conditionalDisplayModal.invalidRegex';
const createItem = () => ({});
exports.createItem = createItem;
const StyledExpandingStackItem = styled_components_1.default.div `
  flex: 1 0 0;
`;
const StyledSubjectStackItem = styled_components_1.default.div `
  flex: 300px 0 0;
`;
const StyledOperatorStackItem = styled_components_1.default.div `
  flex: 200px 0 0;
`;
;
const ConditionLine = (props) => {
    const subject = {
        type: (0, react_final_form_1.useField)(`${props.parent}.type`, {
            validate: (value) => value == null ? (0, utils_1.getSingleText)(RequiredValueText) : undefined,
        }),
        customParamName: (0, react_final_form_1.useField)(`${props.parent}.customParamName`),
        customParamType: (0, react_final_form_1.useField)(`${props.parent}.customParamType`),
        componentType: (0, react_final_form_1.useField)(`${props.parent}.componentType`),
        id: (0, react_final_form_1.useField)(`${props.parent}.id`),
        nebUuid: (0, react_final_form_1.useField)(`${props.parent}.nebUuid`),
    };
    const conditionDefinition = (0, subjectDefinition_1.getSubjectDefinition)(subject.type.input.value, subject.customParamType.input.value, subject.nebUuid.input.value, subject.componentType.input.value, props.components);
    function isValidDate(date) {
        return date instanceof Date && !isNaN(date.getTime());
    }
    const operator = (0, react_final_form_1.useField)(`${props.parent}.operator`, {
        validate: (value, values) => {
            const type = (0, final_form_1.getIn)(values, `${props.parent}.type`);
            return type != null && value == null ? (0, utils_1.getSingleText)(RequiredValueText) : undefined;
        },
    });
    const value = (0, react_final_form_1.useField)(`${props.parent}.value`, {
        validate: (value, values) => {
            const operator = (0, final_form_1.getIn)(values, `${props.parent}.operator`);
            const customParamType = (0, final_form_1.getIn)(values, `${props.parent}.customParamType`);
            if (operator == null || (0, operators_1.isNoValueOperator)(operator)) {
                return undefined;
            }
            if (value == null || (typeof value === 'string' && value.trim().length === 0)) {
                return (0, utils_1.getSingleText)(RequiredValueText);
            }
            if (operator === operators_1.operators.regexp) {
                try {
                    new RegExp(value);
                }
                catch (e) {
                    return (0, utils_1.getSingleText)(InvalidRegexText);
                }
            }
            if (customParamType === 'Datetime' && !isValidDate(value)) {
                return (0, utils_1.getSingleText)(RequiredValueText);
            }
            return undefined;
        },
    });
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement(HorizontalStack_1.default, { gap: "large" },
            react_1.default.createElement(StyledSubjectStackItem, null,
                react_1.default.createElement(SubjectSelect_1.SubjectSelect, { disabled: props.disabled, subject: subject, components: props.components, customParams: props.customParams, operator: operator, value: value })),
            react_1.default.createElement(StyledOperatorStackItem, null,
                react_1.default.createElement(OperatorSelect_1.OperatorSelect, { disabled: props.disabled, subject: subject, operator: operator, value: value, conditionDefinition: conditionDefinition })),
            react_1.default.createElement(StyledExpandingStackItem, null,
                react_1.default.createElement(ValueInput_1.ValueInput, { disabled: props.disabled, operator: operator, value: value, conditionDefinition: conditionDefinition })))));
};
exports.ConditionLine = ConditionLine;
